import { Store } from "dw_azsearchstore";

export interface FacetItem {
    [key: string]: Store.CheckboxFacetItem
}

export const SALES_STEPS: FacetItem = {
    "Lead Generation": {
        count: 0,
        selected: false,
        value: "Lead Generation",
        enabled: true
    },
    "Client Presentation": {
        count: 0,
        selected: false,
        value: "Client Presentation",
        enabled: true
    },
    Offer: {
        count: 0,
        selected: false,
        value: "Offer",
        enabled: true
    },
    "Training And Customer Support": {
        count: 0,
        selected: false,
        value: "Training & Customer Support",
        enabled: true
    },
}

export const TOPICS: FacetItem = {
    Cloud: {
        count: 0,
        selected: false,
        value: "Cloud",
        enabled: true
    },
    Collaborate: {
        count: 0,
        selected: false,
        value: "Collaborate",
        enabled: true
    },
    Compliance: {
        count: 0,
        selected: false,
        value: "Compliance",
        enabled: true
    },
    "ECM Benefits": {
        count: 0,
        selected: false,
        value: "ECM Benefits",
        enabled: true
    },
    Email: {
        count: 0,
        selected: false,
        value: "Email",
        enabled: true
    },
    Forms: {
        count: 0,
        selected: false,
        value: "Forms",
        enabled: true
    },
    Functionality: {
        count: 0,
        selected: false,
        value: "Functionality",
        enabled: true
    },
    Integration: {
        count: 0,
        selected: false,
        value: "Integration",
        enabled: true
    },
    Invoices: {
        count: 0,
        selected: false,
        value: "Invoices",
        enabled: true
    },
    Mobility: {
        count: 0,
        selected: false,
        value: "Mobility",
        enabled: true
    },
    Processes: {
        count: 0,
        selected: false,
        value: "Processes",
        enabled: true
    },
    Search: {
        count: 0,
        selected: false,
        value: "Search",
        enabled: true
    },
    Security: {
        count: 0,
        selected: false,
        value: "Security",
        enabled: true
    },
    Storage: {
        count: 0,
        selected: false,
        value: "Storage",
        enabled: true
    },
    Technology: {
        count: 0,
        selected: false,
        value: "Technology",
        enabled: true
    }
}

export const CLOUD_SOLUTIONS: FacetItem = {
    "Invoice Processing": {
        count: 0,
        selected: false,
        value: "Invoice Processing",
        enabled: true
    },
    "Employee Management": {
        count: 0,
        selected: false,
        value: "Employee Management",
        enabled: true
    },
    "Electronic Signature": {
        count: 0,
        selected: false,
        value: "Electronic Signature",
        enabled: true
    },
    "Purchasing": {
        count: 0,
        selected: false,
        value: "Purchasing",
        enabled: true
    },
    "General information": {
        count: 0,
        selected: false,
        value: "General information",
        enabled: true
    },
    "Sales": {
        count: 0,
        selected: false,
        value: "Sales",
        enabled: true
    },
    "Smart Document Control": {
        count: 0,
        selected: false,
        value: "Smart Document Control",
        enabled: true
    },
    "Municipality": {
        count: 0,
        selected: false,
        value: "Municipality",
        enabled: true
    }
}

export const LANGUAGE: FacetItem = {
    German: {
        count: 0,
        selected: false,
        value: "German",
        enabled: true
    },
    English: {
        count: 0,
        selected: false,
        value: "English",
        enabled: true
    },
    Spanish: {
        count: 0,
        selected: false,
        value: "Spanish",
        enabled: true
    },
    French: {
        count: 0,
        selected: false,
        value: "French",
        enabled: true
    },
    Italian: {
        count: 0,
        selected: false,
        value: "Italian",
        enabled: true
    },
    Portuguese: {
        count: 0,
        selected: false,
        value: "Portuguese",
        enabled: true
    },
    Polish: {
        count: 0,
        selected: false,
        value: "Polish",
        enabled: true
    },
    Dutch: {
        count: 0,
        selected: false,
        value: "Dutch",
        enabled: true
    },
    Japanese: {
        count: 0,
        selected: false,
        value: "Japanese",
        enabled: true
    }
}

export const DOCUMENT_TYPES: FacetItem = {
    Brochure: {
        count: 0,
        selected: false,
        value: "Brochure",
        enabled: true
    },
    "Case Study": {
        count: 0,
        selected: false,
        value: "Case Study",
        enabled: true
    },
    "Envelope Stuffer":{
        count: 0,
        selected: false,
        value: "Envelope Stuffer",
        enabled: true
    },
    "Talk Tracks":{
        count: 0,
        selected: false,
        value: "Talk Tracks",
        enabled: true
    },
    Flyer: {
        count: 0,
        selected: false,
        value: "Flyer",
        enabled: true
    },
    "Legal Document": {
        count: 0,
        selected: false,
        value: "Legal Document",
        enabled: true
    },
    "Online Tool": {
        count: 0,
        selected: false,
        value: "Online Tool",
        enabled: true
    },
    Presentation: {
        count: 0,
        selected: false,
        value: "Presentation",
        enabled: true
    },
    "Product Info": {
        count: 0,
        selected: false,
        value: "Product Info",
        enabled: true
    },
    "Template": {
        count: 0,
        selected: false,
        value: "Template",
        enabled: true
    },
    "Solution Info": {
        count: 0,
        selected: false,
        value: "Solution Info",
        enabled: true
    },
    "Technical White Paper": {
        count: 0,
        selected: false,
        value: "Technical White Paper",
        enabled: true
    },
    "Thought Leadership Paper": {
        count: 0,
        selected: false,
        value: "Thought Leadership Paper",
        enabled: true
    },
    "Version Release Info": {
        count: 0,
        selected: false,
        value: "Version Release Info",
        enabled: true
    },
    Video: {
        count: 0,
        selected: false,
        value: "Video",
        enabled: true
    },
}
export const INDUSTRY: FacetItem = {
    Manufacturing:{
        count: 0,
        selected: false,
        value: "Manufacturing",
        enabled: true
    },
    "Service Provider":{
        count: 0,
        selected: false,
        value: "Service Provider",
        enabled: true
    },
    "Retail Wholesale":{
        count: 0,
        selected: false,
        value: "Retail / Wholesale",
        enabled: true
    },
    "Transportation Logistics":{
        count: 0,
        selected: false,
        value: "Transportation / Logistics",
        enabled: true
    },
    "Finance Banking Insurance":{
        count: 0,
        selected: false,
        value: "Finance / Banking / Insurance",
        enabled: true
    },
    "Property Management":{
        count: 0,
        selected: false,
        value: "Property Management",
        enabled: true
    },
    Healthcare:{
        count: 0,
        selected: false,
        value: "Healthcare",
        enabled: true
    },
    "Municipality Government":{
        count: 0,
        selected: false,
        value: "Municipality / Government",
        enabled: true
    },
    Media:{
        count: 0,
        selected: false,
        value: "Media",
        enabled: true
    },
    Education:{
        count: 0,
        selected: false,
        value: "Education",
        enabled: true
    },
    IT:{
        count: 0,
        selected: false,
        value: "IT",
        enabled: true
    },
    Nonprofit:{
        count: 0,
        selected: false,
        value: "Nonprofit",
        enabled: true
    }
}
//getKeyByDisplayName - gets (key :string) by value
//e.g. getKeyByDisplayName(SALES_STEPS, "Training & Customer Support") => returns "Training_And_Customer_Support"
export const getKeyByDisplayName = (object: FacetItem, displayName: string) :string => {
    let key = Object.keys(object).find(key => object[key].value === displayName);
    //ts doesn't compile return key ?? ""
    return key ? key : "";
};